import { __awaiter } from "tslib";
import { logger } from '@lusha/client-logger';
import { searchCompaniesByName } from '../../API/prospectingAPI';
import { resolveCompany } from './mappers';
import { actions } from './reducer';
class Dispatcher {
    constructor() {
        this.actions = actions;
    }
    setCompany(company) {
        return dispatch => {
            dispatch(actions.setCompany(company));
        };
    }
    setCompanies(companies) {
        return dispatch => {
            if (!companies.length) {
                return;
            }
            dispatch(actions.setCompanies(companies));
        };
    }
    updateCompany(key, changes) {
        return dispatch => {
            if (!key) {
                return;
            }
            dispatch(actions.updateCompany({ key, changes }));
        };
    }
    removeCompany(key) {
        return dispatch => {
            if (!key) {
                return;
            }
            dispatch(actions.removeCompany(key));
        };
    }
    fetchCompanyLid(company) {
        return (dispatch, getState) => __awaiter(this, void 0, void 0, function* () {
            var _a, _b, _c;
            const state = getState();
            const existing = resolveCompany(state.companies, company);
            const name = (existing === null || existing === void 0 ? void 0 : existing.name) || (company && typeof company === 'object' ? company.name : '') || '';
            if (!name) {
                return null;
            }
            if ((existing === null || existing === void 0 ? void 0 : existing.companyLid) != null) {
                return existing.companyLid;
            }
            try {
                const response = yield searchCompaniesByName({
                    company: name,
                    platform: 'Scout',
                    url: state.app.url || '',
                });
                const companyLid = (_c = (_b = (_a = response.companies) === null || _a === void 0 ? void 0 : _a[0]) === null || _b === void 0 ? void 0 : _b.company_lid) !== null && _c !== void 0 ? _c : null;
                if (companyLid == null) {
                    return null;
                }
                if (existing) {
                    dispatch(actions.updateCompany({ key: existing.id, changes: { companyLid } }));
                    if (existing.id !== String(companyLid)) {
                        dispatch(actions.setCompany(Object.assign(Object.assign({}, existing), { id: String(companyLid), companyLid })));
                    }
                }
                return companyLid;
            }
            catch (error) {
                logger.info('Failed to fetch company lid: ', error);
                return null;
            }
        });
    }
}
const CompaniesDispatcher = new Dispatcher();
export default CompaniesDispatcher;
